<template>
    <div id="root" class="root">
        <div id="contact-header-wrapper" class="footHeaderWrapper">
            <searchables-header @inputSubmit="onInputSubmit" />
        </div>
        <div id="contact-body-wrapper" class="footBodyWrapper">
            <h1>Contact Us</h1>

            <p>
                Searchables, the official website of Searchables extension, is
                committed to making your user experience pleasant and productive
                while using this site.
            </p>

            <p>
                Should you have any additional questions, comments, or
                compliments, you can also reach us via email at
                <a href="mailto:contactus@Searchables.com" target="_top"
                    ><span
                        class="__cf_email__"
                        data-cfemail="contactus@Searchables.com"
                        >contactus@Searchables.com</span
                    ></a
                >
                You can also send snail mail to the address below. We welcome
                your feedback!
            </p>
            <p style="color: #2464cf; padding-top: 50px"></p>

            <p>
                Tightrope Interactive, Inc.<br />
                588 Sutter St #551<br />
                San Francisco,<br />
                CA 94102<br />
            </p>

            <p>Thanks for your support!</p>

            <p>-The Searchables Team</p>
        </div>
        <div id="contact-footer-wrapper" class="footFooterWrapper">
            <Searchables-footer />
        </div>
    </div>
</template>

<script>
import SearchablesFooter from "@/components/footer/SearchablesFooter.vue";
import SearchablesHeader from "../../../../components/header/SearchablesHeader.vue";
import { pageview } from "../../../../analytics.js";

export default {
    components: {
        "Searchables-footer": SearchablesFooter,
        SearchablesHeader,
    },
    mounted() {
        pageview();
    },
    methods: {
        onInputSubmit(data) {
            if (data.query)
                window.open(
                    `/search?q=${data.query}${
                        data.isManualSearch ? `?ms=true` : ""
                    }`
                );
        },
    },
};
</script>

<style>
@import "./contact.css";
</style>
